import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import './gridPanel.scss'
import { Responsive, WidthProvider } from "react-grid-layout";
import '../../../../node_modules/react-grid-layout/css/styles.css'
import '../../../../node_modules/react-resizable/css/styles.css'
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Icon, { IconSize, IconType } from '../../atoms/icon/icon';
import { useEffect } from 'react';
import FormMultipleRelationship from '../../organisms/formMultipleRelationship/formMultipleRelationship';
import { isEmpty } from 'lodash';
import swal from 'sweetalert';

const ResponsiveGridLayout = WidthProvider(Responsive);


const GridPanel = (props) => {
  const {
    configFile,
    onChange,
    onRemovePanel,
    placement,
    value,
    isPreview
  } = props;

  const permittedSizes = ['1x1', '1x2','2x1','2x2','2x3','3x2','2x4','4x2','4x4',]
  const imageSize = {
    '1x1': 'xs',
    '1x2': 'sVertical',
    '2x1': 'sHorizontal',
    '4x1': 'sFullWidth',
    '2x2': 'm',
    '2x3': 'lVertical',
    '3x2': 'lHorizontal',
    '2x4': 'xlVertical',
    '4x2': 'xlHorizontal',
    '4x4': 'xxl',
  }

  const [board, setBoard] = useState([])
  const [beforeResize, setBeforeResize] = useState([])
  const [canCreate, setCanCreate] = useState(true);
  const [blockGrid,setBlockGrid] =useState(false);

  useEffect(() => {
    if (value !== '' && value !== board) {
      setBoard(value);
      checkCanCreateNewItem(value);
    }
  }, [value]);

  const findEmptyPosition = (board) => {
    const positionCandidates = [
      [0,0],[0,1],[0,2],[0,3],
      [1,0],[1,1],[1,2],[1,3],
      [2,0],[2,1],[2,2],[2,3],
      [3,0],[3,1],[3,2],[3,3],
    ];
    let selectedPosition;
    for(let  i = 0; i < positionCandidates.length; i++){
      const positionCandidate = positionCandidates[i];
      const boardItemInPosition = board.find((boardItem) => {
        const boardItemMaxX = boardItem.x + boardItem.w - 1;
        const boardItemMaxY = boardItem.y + boardItem.h - 1;
        return boardItem.x <= positionCandidate[0] 
          && boardItemMaxX >= positionCandidate[0] 
          && boardItem.y <= positionCandidate[1]
          && boardItemMaxY >= positionCandidate[1];
      });
      if(!boardItemInPosition){
        selectedPosition = positionCandidate;
        break;
      }
    }
    return selectedPosition;
  };

  const checkCanCreateNewItem = (newBoard) => {
    // Check if the grid panel has empty space
    setCanCreate(findEmptyPosition(newBoard) !== undefined);
  };

  const handleAddBlock = () => {
    const selectedPosition = findEmptyPosition(board);
    //Creating the new board item
    if(selectedPosition){
      //Get max index
      const newIndex = board.reduce((carry, boardItem) => {
        return boardItem.i >= carry ? boardItem.i + 1 : carry;
      }, 1);
      let newBoard = [
        ...board,
        {
          i: newIndex,
          x: selectedPosition[0],
          y: selectedPosition[1],
          w:1,
          h:1,
          content:null,
          placement:placement
        }
      ]
      setBoard(newBoard);
      onChange(newBoard);
      checkCanCreateNewItem(newBoard);    
    } 
  };
  const handleRemoveBlock = (item) => {
    setBlockGrid(true);
    swal({
      title: 'Remove a panel?',
      text: 'You are about to remove a panel, and there´s no way back from this action',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        setBlockGrid(false);
        let filteredBoard = board.filter((block) => { 
          if(item !== block.i){
            return block
          }
        });
        onChange(filteredBoard);
        setBoard(filteredBoard);
        setCanCreate(true);
      }
    });   
   
  };
  const getImage = (item, size) => {
    return item['content'][size] ? item['content'][size]['url'] : null 
  }
  const handleResize = (layout, oldLayoutItem, layoutItem, placeholder) => {
    if(!permittedSizes.includes(layoutItem.w+'x'+layoutItem.h)){
      layoutItem.w = 2;
      placeholder.w = 2;
    }
    layout.map(item=>{
      board.map(boardItem=>{
        if(item.i == boardItem.i){
          item["placement"] = boardItem.placement
          item["content"] = boardItem.content
          item["type"] = boardItem.type
        }
      });
    })
    checkCanCreateNewItem(board);
    onChange(layout)
  };

const handleRemovePanel = () => {
  swal({
    title: 'Are you sure?',
    text: 'You are about to remove a panel, and there´s no way back from this action',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((ok) => {
    if(ok){
      onRemovePanel(placement);
    }
  });   
 
};
const handleChange = (content, target) => {
  const newBoard = board.map(element => {
    if(element.i === target){
      element.content = content.target.value
      element.type = Array.isArray(element.content) && element.content[0] &&  !element.content.type ? element.content[0].type : element.content.type;
      element.name = element.content.type
      if(element.content.url){
        element.url = element.content.url
      }
    }
    return element;
  });
  onChange(newBoard)
  setBoard(newBoard)  
};
const handleOnCloseMultipleRelationship=()=>{
  setBlockGrid(false);
}
const handlerOnCreateMultipleRelationship=()=>{
  setBlockGrid(true);
}

  return (
     <div >
       { !isPreview
          && (
            <div className='panel-buttons'>
              { canCreate &&
                <Button
                  key={`button-`}
                  className="mr-2"
                  id={`button--add`}
                  type={ButtonType.BUTTON}
                  icon={IconType.NEW}
                  theme={ButtonTheme.PRIMARY}
                  onClick={handleAddBlock}
                ></Button>
              }
              <Button
                key={`button-delete-`}
                className="mr-2"
                id={`button--delete`}
                type={ButtonType.BUTTON}
                icon={IconType.DELETE}
                theme={ButtonTheme.ERROR}
                onClick={handleRemovePanel}
              ></Button>
          </div>
      )}
      <div className="grid-panel">
        <ResponsiveGridLayout
          className="layout panel"
          cols={{ lg: 4, md: 4, sm: 4, xs: 4, xxs: 4 }}
          layout={board}
          isBounded={true}
          width={20}
          maxRows={4}
          rowHeight={100}
          preventCollision={true}
          compactType={null}
          onResize={handleResize}
          onDragStop={handleResize}
          isDraggable={!blockGrid && !isPreview}
          isResizable={!blockGrid && !isPreview}

        >
            {
              board.map((item, key)=>{
                return (
                  <div id={`panel-item-${item.i}`} key={item.i} data-grid={item}>
                  { !isPreview
                    && (
                    <div 
                      style={{"display":"flex", "justifyContent":"center", "alignItems":"center",  "height":"100%"} }
                    >
                      <div style={{"overflow":"hidden"} }>
                          <FormMultipleRelationship
                            itemId={placement + '-' +key}
                            configFile={configFile.fields[0]}
                            buttonColor={ButtonTheme.SECONDARY_OUTLINE}
                            value={item.content ? item.content : {}}
                            onChange={(change)=>handleChange(change, item.i)}
                            onClose={handleOnCloseMultipleRelationship}
                            onCreate={handlerOnCreateMultipleRelationship}
                            newAlways
                          />
                      </div>
                        
                      </div>
                      )}
                      { !isPreview
                        && (
                          <span 
                            id={`remove-poster-item`}
                            style={{"position":'absolute', "right":"2px", "top":0, "cursor":"pointer", "marginRight":"5px", "fontWeight":"bold"}}
                            onClick={()=>handleRemoveBlock(item.i)}
                          >x</span>
                      )}
                      { isPreview && item.content && !Object.keys(item.content).length == 0
                        && (
                            <img 
                              className={"item-img"}
                              alt={"No image has been added for this size"}
                              src={getImage(item, imageSize[item.w+'x'+item.h]) ? getImage(item, imageSize[item.w+'x'+item.h]) : ''}
                            />
                      )}
                  </div>
                )
              })
            }
          </ResponsiveGridLayout>
        </div>
      </div>
  );
};

GridPanel.propTypes = {
  className: PropTypes.string,
      /**
   * Data set change event
   */
  onChange: PropTypes.func,
  onRemovePanel: PropTypes.func,
};

GridPanel.defaultProps = {
  className: '',
  onChange: () => {},
  onRemovePanel: () => {},
};

export default GridPanel;
